import React from "react";
import Marquee from "react-fast-marquee";
import "./marquee.css";

export default function MarqueeBanner() {
  return (
    <div className="marquee">
      <Marquee speed={80} direction="right">
        <span>FREE Breakfast, Lunch, and Snacks Served Daily!</span>
      </Marquee>
    </div>
  );
}
